import { render, staticRenderFns } from "./Allgemeines.vue?vue&type=template&id=70bfdc5e&scoped=true&"
import script from "./Allgemeines.vue?vue&type=script&lang=js&"
export * from "./Allgemeines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bfdc5e",
  null
  
)

export default component.exports